// extracted by mini-css-extract-plugin
export default {"grid":"XqM11YH9nS_7qJrptQ4d","separator":"nl2ioVucdCVuLLvTiedw"};